export const ROLE_ALIASES: Record<string, string> = {
  admin: 'admin',
  administrador: 'admin',
  administrator: 'admin',
  pilot: 'pilot',
  piloto: 'pilot',
  partner: 'partner',
  parceiro: 'partner',
}

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
  admin: 'Administrador',
  pilot: 'Piloto',
  partner: 'Cotista',
}

export const normalizeRole = (role: string | undefined | null): string | null => {
  if (!role) return null
  const normalized = role.trim().toLowerCase()
  if (!normalized) return null
  return ROLE_ALIASES[normalized] ?? normalized
}

export const normalizeRoles = (roles: unknown): string[] => {
  const normalized = new Set<string>()

  const collect = (candidate: unknown) => {
    if (!candidate) return
    if (Array.isArray(candidate)) {
      candidate.forEach(collect)
      return
    }
    if (typeof candidate === 'string') {
      const value = normalizeRole(candidate)
      if (value) normalized.add(value)
    }
  }

  collect(roles)
  return Array.from(normalized.values())
}

export const roleDisplayLabel = (role: string | undefined | null): string => {
  const normalized = normalizeRole(role)
  if (!normalized) return ''
  return ROLE_DISPLAY_NAMES[normalized] ?? normalized
}
